/* ===========================================================================
   LMP portal — live sync. Wires the Shipping panel, receipt upload, and the
   preferences form to the ops backend through the Shopify App Proxy
   (/apps/lmp/portal/...). Shows clean "syncing…" states until the proxy is
   connected, so the portal looks finished before go-live.
   =========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-lmp-portal]');
  if (!root) return;
  var BASE = (window.LMP_APP_PROXY || '/apps/lmp/portal').replace(/\/$/, '');
  var loggedIn = root.getAttribute('data-logged-in') === '1';

  function el(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstElementChild; }
  function fmtDate(d) { if (!d) return '—'; try { return new Date(d).toLocaleDateString(); } catch (e) { return '—'; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* -------------------------------------------------- shipments (Shipping tab) */
  var shipList = document.querySelector('[data-ship-list]');
  function shipState(icon, msg) {
    if (shipList) shipList.innerHTML =
      '<div class="lmp-portal-empty"><div class="lmp-portal-empty-ic">' + icon + '</div><p>' + esc(msg) + '</p></div>';
  }
  function renderShipments(data) {
    if (!shipList) return;
    if (!data.matched) { shipState('🔄', 'We are linking your account to our system. Your shipments will appear here shortly.'); return; }
    if (!data.boxes || !data.boxes.length) { shipState('📦', 'No shipments yet. Once we receive a package for you, it shows up here with live tracking.'); return; }
    shipList.innerHTML = data.boxes.map(function (b) {
      var bl = b.container && b.container.blNumber;
      var eta = b.container && b.container.eta;
      var timeline = (b.timeline || []).map(function (t) {
        return '<li><span>' + esc(t.status) + '</span><em>' + fmtDate(t.at) + '</em></li>';
      }).join('');
      var charges = b.charges && (b.charges.vatUsd || b.charges.landedUsd)
        ? '<div class="lmp-ship-charges">VAT $' + (b.charges.vatUsd || 0) + ' · Landed $' + (b.charges.landedUsd || 0) + '</div>' : '';
      var blLine = b.releasedToCustomer
        ? '<div class="lmp-ship-bl">🚢 Your goods have left the US' + (bl ? ' — B/L ' + esc(bl) : '') + (eta ? ' · ETA ' + fmtDate(eta) : '') + '</div>' : '';
      return '<div class="lmp-ship-card">'
        + '<div class="lmp-ship-head"><b>' + esc(b.code) + '</b><span class="lmp-ship-status lmp-ss-' + esc(b.statusKey) + '">' + esc(b.status) + '</span></div>'
        + blLine + '<ol class="lmp-ship-timeline">' + timeline + '</ol>' + charges + '</div>';
    }).join('');
  }
  function loadShipments() {
    if (!shipList) return;
    shipState('⏳', 'Loading your shipments…');
    fetch(BASE + '/shipments', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { if (j.loggedIn === false) shipState('🔑', 'Please log in to see your shipments.'); else renderShipments(j); })
      .catch(function () { shipState('🔄', 'Syncing… your live shipment tracking is being connected. Please check back soon.'); });
  }

  /* -------------------------------------------------- preferences (Customer info) */
  var infoForm = document.querySelector('[data-portal-info]');
  if (infoForm) infoForm.addEventListener('submit', function (e) {
    var msg = infoForm.querySelector('[data-portal-msg]');
    var v = function (n) { var f = infoForm.querySelector('[name="' + n + '"]'); return f ? f.value : ''; };
    var pickup = (infoForm.querySelector('[name="fulfilment"]:checked') || {}).value === 'pickup';
    var body = { addressStreet: v('street'), city: v('city'), postalCode: v('postal'), deliveryPref: pickup ? 'DROP_OFF' : 'DELIVERY' };
    // Do not preventDefault-block the existing localStorage save; run in parallel.
    fetch(BASE + '/preferences', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (msg && j.ok) msg.textContent = 'Saved to your account ✓'; })
      .catch(function () { /* stays saved on-device until proxy connects */ });
  });

  /* -------------------------------------------------- receipt upload */
  var receiptInput = document.querySelector('[data-portal-receipt]');
  if (receiptInput) receiptInput.addEventListener('change', function () {
    var f = receiptInput.files && receiptInput.files[0];
    if (!f) return;
    var fd = new FormData(); fd.set('file', f);
    var note = el('<span style="margin-left:8px;font-size:13px;color:var(--text-muted,#64708c)">Uploading…</span>');
    receiptInput.parentNode.appendChild(note);
    fetch(BASE + '/receipts', { method: 'POST', credentials: 'same-origin', body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { note.textContent = res.ok ? 'Uploaded ✓' : (res.j.error || 'Saved — sync connecting.'); receiptInput.value = ''; })
      .catch(function () { note.textContent = 'Saved — live sync connecting.'; });
  });

  if (loggedIn) loadShipments();
})();
